import React from "react";
import Pagination from "react-js-pagination";

const DEFAULT_PAGE_SIZE_OPTIONS = [25, 50, 75, 100];

function PhanTrang(props) {
  const {
    pageIndex = 1,
    pageSize = 25,
    totalCount = 0,
    onPageChange,
    onPageSizeChange,
    pageSizeOptions = DEFAULT_PAGE_SIZE_OPTIONS,
    pageRangeDisplayed = 5,
    showPageSize = true,
  } = props;

  const from = totalCount === 0 ? 0 : (pageIndex - 1) * pageSize + 1;
  const to = Math.min(pageIndex * pageSize, totalCount);

  const handlePageSizeChange = (e) => {
    if (onPageSizeChange) onPageSizeChange(Number(e.target.value));
  };

  return (
    <div className="row">
      <div className="col-sm-12 col-md-6 d-flex align-items-center">
        <span className="color7">
          {showPageSize && (
            <span className="d-inline-flex align-items-center ml-1">
              <span className="color7 ml-2">Hiển thị&nbsp; </span>
              <select
                className="form-control form-control-sm"
                style={{
                  width: "auto",
                  display: "inline-block",
                  height: "32px",
                  padding: "2px 30px 2px 12px",
                  border: "1px solid #ced4da",
                  borderRadius: "6px",
                  fontWeight: 500,
                  color: "#495057",
                  backgroundColor: "#fff",
                  boxShadow: "0 1px 2px rgba(0, 0, 0, 0.06)",
                  cursor: "pointer",
                  appearance: "none",
                  WebkitAppearance: "none",
                  MozAppearance: "none",
                  backgroundImage:
                    "url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='10' height='6' viewBox='0 0 10 6'%3E%3Cpath fill='%23888' d='M0 0l5 6 5-6z'/%3E%3C/svg%3E\")",
                  backgroundRepeat: "no-repeat",
                  backgroundPosition: "right 10px center",
                  backgroundSize: "10px 6px",
                }}
                value={pageSize}
                onChange={handlePageSizeChange}
              >
                {" "}
                {pageSizeOptions.map((size) => (
                  <option key={size} value={size}>
                    {size}
                  </option>
                ))}
              </select>
            </span>
          )}
          &nbsp;
          {totalCount === 0
            ? "0 - 0 / Tổng số 0"
            : `${from} - ${to} / Tổng số ${totalCount}`}
        </span>
      </div>
      <div className="col-sm-12 col-md-6">
        <div
          className={
            "paniation-new paniation-new1 d-flex justify-content-center " +
            (totalCount === 0 ? "hidden" : "")
          }
          style={{ float: "right" }}
        >
          <nav aria-label="Page navigation">
            <Pagination
              activePage={pageIndex}
              itemsCountPerPage={pageSize}
              totalItemsCount={totalCount}
              pageRangeDisplayed={pageRangeDisplayed}
              onChange={onPageChange}
              itemClass="page-item border-none"
              linkClass="page-link border-none"
              activeClass="active"
            />
          </nav>
        </div>
      </div>
    </div>
  );
}

export default PhanTrang;
